import type { ShellContext } from "../types";

/** `canSeeTimeSheet` off: no sidebar item and /timesheet goes to /tracker (timesheet spec 12 item 1). */
export function timesheetOn(ctx: ShellContext): boolean {
  return ctx.workspaceSettings.canSeeTimeSheet !== false;
}
